import React from 'react';
import { gql, useQuery, useParams } from '@common/hooks';
import PropTypes from 'prop-types';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { SupplierCandidateProfile } from 'works/components/supplier-candidate-profile';
import { StaffingRequestAssignmentPageHeader } from 'works/components/staffing-request-assignment-page-header';
import { ErrorHandler, LoadingState } from '@common/components';

const SUPPLIER_CANDIDATE_PROFILE = gql`
  query supplierCandidateProfile($id: ID!) {
    worksProfile(id: $id) {
      id
      firstName
      lastName
      fullName
      phone
      email

      currentStaffingRequestAssignment {
        id
        ...StaffingRequestAssignmentPageHeaderInfo
      }
    }
  }

  ${StaffingRequestAssignmentPageHeader.fragments.headerInformation}
`;

export function SupplierCandidatePage() {
  const { worksProfileId } = useParams();

  const { loading, error, data } = useQuery(SUPPLIER_CANDIDATE_PROFILE, {
    variables: { id: worksProfileId },
  });

  if (loading && !data) {
    return <LoadingState />;
  }

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="CandidatePage::SUPPLIER_CANDIDATE_PROFILE"
      />
    );
  }

  const worksProfile = data.worksProfile;
  const candidateFullName = worksProfile.fullName;

  setBreadcrumbs([
    { name: 'Candidates', path: '/works/supplier/candidates' },
    {
      name: candidateFullName,
      path: `/works/supplier/candidates/${worksProfileId}`,
    },
  ]);

  return (
    <React.Fragment>
      {worksProfile.currentStaffingRequestAssignment && (
        <StaffingRequestAssignmentPageHeader
          staffingRequestAssignment={
            worksProfile.currentStaffingRequestAssignment
          }
        />
      )}
      <SupplierCandidateProfile worksProfileId={worksProfileId} />
    </React.Fragment>
  );
}

SupplierCandidatePage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      worksProfileId: PropTypes.string.isRequired,
    }),
  }),
};
